import React, { useState, useEffect } from 'react';

import { Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';

import Login from './Login';

import { onAuthStateChanged } from "firebase/auth";
import { auth } from '../firebaseConfig/firebase';
import { doc, setDoc, collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig/firebase';


function Upload() {

    const [valido, setValido] = useState();
    const [importOk, setImportOk] = useState();
    const [count, setCount] = useState(0);

    const schema = yup.object().shape({
        nombre: yup.string().required().min(6,),

    });


    // ENVIAR CORREO NEXT GEN
    const sendEmail = async (nombre, mailEscac, mailPersonal) => {

        try {
            const collectionRef = collection(db, 'email');
            const emailContent = {
                to: mailPersonal,
                message: {
                    subject: `Te damos la bienvenida`,
                    html: `                      
                        <body>
                            <div style="width: 70%; max-width: 700px; margin: auto;">
                                <div style="margin: 0px; padding: 0px">
                                    <img style="width: 100%; border-top-left-radius: 80px ; border-top-right-radius: 80px;"
                                        src="https://ff.escac.com/images/logo_fastforward.png">
                                </div>
                                <div style="padding-left: 20px; padding-right: 20px; font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif">
                                    <div style="padding-top: 20px;">
                                        <p>Hola ${nombre}</p>
                                        <p>Al formar parte de FastForward des del departamento TIC te damos las indicaciones para utilizar tu cuenta de correo. </p>
                                        <p style="margin-top: 10px; text-align: justify;">
                                            <strong>Usuario</strong> : ${mailEscac} </br>
                                            <strong>Password inicial</strong>: Fastforward2324
                                            
                                         </p>
                                         <p>En el siguiente enlace encontrarás el Tutorial con los pasos para activar tu cuenta. </p>
                                         <a href=https://ff.escac.com/manuals/Tutorial_Login_GSuite_FF.pdf> Let's Go! </a>
                        
                                    </div>
                                    
                                    <div style="margin-top: 30px;">
                                    <p>Para cualquier duda estamos a tu disposición <strong>tic@escac.es</strong></p>
                                        <p style="margin-top: 5px;">Un saludo y muchas gracias.</p>
                                    </div>
                                </div>
                            </div>`,
                }
            }
            var date = new Date().getTime();
            var date = date.toString();
            await setDoc(doc(db, 'email', date), emailContent);
            //addDoc(collectionRef, emailContent);
            console.log("Email Sended");
            setImportOk("¡Correos enviados!");
            setCount(count + 1);

        } catch (error) {
            console.log(error);
        }

    }

    function envioCorreos(info, infoLength, x){
        console.log(info, infoLength)
        if (x < infoLength) {
            setTimeout(() => envioCorreos(info, infoLength, x+1), 3000)
            const nombre = info[x].nombre;
            const mail = info[x].mailEscac;
            const mailPersonal = info[x].mailPersonal;

            sendEmail(nombre, mail, mailPersonal);

        }
        
    }


    // CREAR DOCUMENTO FIREBASE
    const enviar = async (values) => {
        var date = new Date().getTime();
        date = date.toString();

        try {
            await setDoc(doc(db, 'Correos', date), {
                ...values
            })
            console.log("Sended");

            const docs = []
            const body = JSON.parse(values.nombre)
            docs.unshift(body)


            const info = docs[0];
            const infoLength = docs[0].length;

            envioCorreos(info, infoLength, 0)
        
        } catch (error) {
            console.log(error);
        }
    }


    // AUTHENTICACIÓN
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {

                setValido(true);

            } else {
                setValido(false);
                console.log("user is logged out")

            }
        });

    }, [])



    if (valido) return (
        <>
            <Formik
                validationSchema={schema}
                onSubmit={enviar}
                initialValues={{
                    nombre: ''
                }}
                validateOnMont>

                {({ handleSubmit, handleChange, values, errors, isValid }) => (

                    <Form className="p-3" noValidate onSubmit={handleSubmit}>
                        <Form.Group controlId="nombre" className="mb-4">

                            <Form.Label className="form-label mb-0">
                                <h2>ENVIAR CORREU DE BENVINGUDA</h2>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={20}
                                name="nombre"
                                className="form-control border-dark ps-1 pb-1 fw-bold"
                                value={values.nombre}
                                onChange={handleChange}

                            />
                        </Form.Group>



                        <Button
                            variant="dark"
                            type="submit"
                            value="Enviar"
                            as="input"
                            disabled={!isValid}
                        //onClick={() => { handleClose(); }}
                        >
                        </Button>
                    </Form>
                )}

            </Formik>
            <p>{importOk}</p>
            <p>{count}</p>



        </>
    )

    return (
        <Login />
    )

}

export default Upload